module.exports = __webpack_public_path__ + "img/tongxin.49b1ab32.jpg";